import { useState } from "react";
import { noticeError } from "../../../App.newrelic";
import { APP_API_URL } from "../../../config/Environment";
import { useToken } from "./token";

const defaultOpts = { method: "GET", values: null };

export const useFetchOnDemand = (
  opts = defaultOpts,
) => {
  const { token, LiveToken } = useToken();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  function combineData(currentData, addedData) {
    let data = currentData.data.concat(addedData.data);
    currentData.data = data;
    return currentData;
  }

  const getData = async function(input, opts = defaultOpts) {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const url = APP_API_URL + input;
    const { readBody = (body) => body.json() } = opts;

    await LiveToken().validateToken();

    if (token) {
      setLoading(true);
      let tokenType =
        token.tokenType.charAt(0).toUpperCase() +
        token.tokenType.substr(1).toLowerCase();

      try {
        const response = await fetch(url, {
          method: opts.method,
          headers: {
            Authorization: `${tokenType} ${token.token}`,
          },
          signal: signal,
          ...(opts?.values && { body: JSON.stringify(opts.values) }),
        });

        if (response.ok) {
          const body = await readBody(response);
          setLoading(false);
          return body;
        } else {
          const body = await readBody(response);
          console.log("error", body);
          setError(body.message ?? body.error?.message);
          setLoading(false);
        }
      } catch (e) {
        console.log("E", e);
        noticeError(e);
        setError("An error occurred while fetching data.");
        setLoading(false);
      }
    }
  }

  const getAllData = async function(input, opts, all) {
    try {
      const results = await getData(input, opts);
      if (results) {
        if (results.links && results.links.next && all) {
          return combineData(results, await getAllData(results.links.next, opts));
        } else {
          return results;
        }
      }
    } catch (e) {
      console.log("E", e);
      noticeError(e);
    }
  };

  const fetchOnDemand = async (input, opts, all) => {
    return await getAllData(input, opts, all);
  };

  return { fetchOnDemand, error, loading, token };
};
